import { Component, ViewChild, Output, EventEmitter, Input, OnInit } from '@angular/core';

import { GatewayServiceProvider, AlertService } from './../../../_services/services';
import { BookingBookModel } from "../../../_models/booking/booking-book.model";
import { Global } from 'src/app/globals';
import utils from 'src/app/utils';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { AppSignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
    selector: 'app-book',
    templateUrl: './book.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MaterialModule
    ],
})

export class BookComponent implements OnInit {
    @Output() cancelBook = new EventEmitter<any>();
    @Output() confirmBook = new EventEmitter<BookingBookModel>();
    @Output() confirmSplitBook = new EventEmitter<BookingBookModel>();
    @Input() qoutebookRemarks: string;
    @Input() bookingProgramDropdownItems: any[];
    @Input() bookingProgramDropdownStatus: boolean = false;
    @Input() bookingProgramDropdownRequired: string = "Required";
    @Input() remarksCommenLimit: number = 300;
    @Input() quoteSignature: string;
    @Input() PendingSignatureRequiredStatus: boolean = false;
    @Input() showFarmAndFields: boolean;

    @ViewChild('signature')
    public signaturePad!: AppSignaturePadComponent;

    bookRemarks: BookingBookModel;
    isSign: boolean = false;
    isSignatureRequired: boolean = false;
    maxIncidentDescriptionLength: number = 50;
    requiredBookingPrepay: boolean = false;

    showImage() {
        this.bookRemarks.signatureImage = this.signatureImage;
        this.isSignatureRequired = false;
    }
    public signatureImage: string;

    constructor(
        public globals: Global,
        private gatewayService: GatewayServiceProvider,
        public alertService: AlertService) {
        // this.canvasResize();

        this.gatewayService.getAgentVersion((response) => {
            var version = parseInt(
                response.Version.replace(".", "").replace(".", "")
            );
            if (version <= 1840) {
                this.maxIncidentDescriptionLength = 50;
            } else {
                this.maxIncidentDescriptionLength = this.remarksCommenLimit;
                if (this.bookRemarks.bookRemarks.length > this.remarksCommenLimit) {
                    this.bookRemarks.bookRemarks = this.bookRemarks.bookRemarks.substring(0, this.remarksCommenLimit);
                }
            }
        }, (error) => { })
        this.bookRemarks = new BookingBookModel();
    }

    ngOnInit(): void {


    }

    ngAfterViewInit() {
        if (this.signaturePad) {
            this.signaturePad.clear();
        }

    }

    drawComplete(signatureDataUrl?: string | Event) {
        const signatureImage = typeof signatureDataUrl === 'string'
            ? signatureDataUrl
            : this.signaturePad?.toDataUrl() || '';

        console.log('Completed drawing');
        console.log(signatureImage);
        if (this.isSignatureRequired) {
            if (!signatureImage || this.signaturePad.isEmpty()) {

                utils.confirmationDialog('Warning', "Signature is Required.", 'Close', (result) => {
                    if (result == 'Close') {
                        this.signatureImage = undefined;
                        this.signatureRequired();
                    }

                }, false);


            } else {
                let Signatureimage2: string = this.getSignaturePayload(signatureImage);
                console.log(Signatureimage2);
                this.signatureImage = signatureImage;
                this.bookRemarks.signatureImage = Signatureimage2;

                this.showImage();
            }


        }
        else {
            let Signatureimage2: string = this.getSignaturePayload(signatureImage);
            console.log(Signatureimage2);
            this.signatureImage = signatureImage;
            this.bookRemarks.signatureImage = Signatureimage2;

            this.showImage();
        }



    }

    drawStart() {
        console.log('Start drawing');
    }

    clear() {
        this.signaturePad.clear();
    }

    private getSignaturePayload(signatureImage: string): string {
        return signatureImage.replace(/^data:image\/png;base64,/, '');
    }

    ngAfterContentInit() {


        this.bookRemarks.bookRemarks = this.qoutebookRemarks ? this.qoutebookRemarks : '';
        if (this.quoteSignature) {
            this.isSign = true;
            this.signatureImage = this.quoteSignature;
        }
        this.signatureRequired();
    }

    signatureRequired() {

        if (this.PendingSignatureRequiredStatus && this.isSign == false && this.signatureImage == undefined) {
            this.isSignatureRequired = true;
            this.sign();

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage != undefined) {
            this.isSignatureRequired = false;

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage == undefined) {
            this.isSignatureRequired = true;

        } else if (this.PendingSignatureRequiredStatus == false) {
            this.isSignatureRequired = false;

        }


    }



    sign() {
        this.isSign = true;
    }
    resign() {
        this.signatureImage = undefined;
        this.signatureRequired();


    }
    cancel() {
        this.cancelBook.emit();
    }
    finishBook() {
        if (this.bookingProgramDropdownStatus == true && this.bookingProgramDropdownItems.length > 0) {
            this.requiredBookingPrepay = false;
            if (this.bookingProgramDropdownRequired == "Required" && !this.bookRemarks.bookingProgram) {
                this.requiredBookingPrepay = true;
                this.bookRemarks.mode = "Book";
                this.bookRemarks.signatureImage = this.signatureImage;
                this.confirmBook.emit(this.bookRemarks);
                return;
            }
            if (this.bookRemarks.bookingProgram) {
                let bookingProgram = this.bookingProgramDropdownItems.find(x => x.Value == this.bookRemarks.bookingProgram);
                // let bookingProgram = this.bookingProgramDropdownItems.find(x => x.Value == "tereethjhj");
                if (bookingProgram)
                    this.bookRemarks.otherNumber = bookingProgram.Name;
            }

        }

        // Helpers.LogInfo('PostBooking - Book');
        this.bookRemarks.mode = "Book";
        this.bookRemarks.signatureImage = this.signatureImage;
        this.confirmBook.emit(this.bookRemarks);
    }
    finishSplitBook() {
        if (this.bookingProgramDropdownStatus == true && this.bookingProgramDropdownItems.length > 0) {
            this.requiredBookingPrepay = false;
            if (this.bookingProgramDropdownRequired == "Required" && !this.bookRemarks.bookingProgram) {
                this.requiredBookingPrepay = true;
                this.bookRemarks.mode = "Book";
                this.bookRemarks.signatureImage = this.signatureImage;
                this.confirmBook.emit(this.bookRemarks);
                return;
            }
            if (this.bookRemarks.bookingProgram) {
                let bookingProgram = this.bookingProgramDropdownItems.find(x => x.Value == this.bookRemarks.bookingProgram);
                if (bookingProgram)
                    this.bookRemarks.otherNumber = bookingProgram.Name;
            }
        }
        // Helpers.LogInfo('PostBooking - Book');
        this.bookRemarks.mode = "Book";
        this.bookRemarks.signatureImage = this.signatureImage;
        this.confirmSplitBook.emit(this.bookRemarks);
    }
    onSelectBookingProgram($event) {
        this.requiredBookingPrepay = false;
        if (this.bookRemarks.bookingProgram) {
            if (this.maxIncidentDescriptionLength > 250) {
                if (this.bookRemarks.bookRemarks.length > 250) {
                    this.bookRemarks.bookRemarks = this.bookRemarks.bookRemarks.split('').splice(0, 250).join('');
                }
                this.maxIncidentDescriptionLength = this.maxIncidentDescriptionLength - 50;

            }
        } else {
            this.maxIncidentDescriptionLength = 300;
        }

    }

    changeIsByPhone($event) {
        if (this.bookRemarks.bookRemarks.match(' -By Phone Call') == null) {
            $event.source.checked = true;
            if (this.maxIncidentDescriptionLength - this.bookRemarks.bookRemarks.length >= 16) {
                this.bookRemarks.bookRemarks = this.bookRemarks.bookRemarks + ' -By Phone Call';
                this.alertService.clear();
            }
            else {
                this.alertService.error("Please remove at least 16 characters to enable this feature.");
                $event.source.checked = false;
            }
        }
        else {
            this.bookRemarks.bookRemarks = this.bookRemarks.bookRemarks.replace(' -By Phone Call', '');
        }
    }
}